import { reducersActions } from "../actions/new-actions";

const {
  FETCH_CAMPAIGN_REQUEST,
  FETCH_CAMPAIGN_SUCCESS,
  FETCH_CAMPAIGN_FAILURE,
} = reducersActions;

const initialState = {
  loading: false,
  campaign: null,
  error: null,
};

const campaignNewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CAMPAIGN_SUCCESS:
      return { ...state, loading: false, campaign: action.payload };
    case FETCH_CAMPAIGN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case "RESET_CAMPAIGN":
      return { ...state, campaign: null, loading: false, error: null };
    case "UPDATE_CAMPAIGN_FIELD":
      return {
        ...state,
        campaign: {
          ...state.campaign,
          ...action.payload, // Merges only the updated field(s)
        },
      };
    default:
      return state;
  }
};

export default campaignNewReducer;
